import Permission from "../../permission";

export default class PermissionAPICommand {
  public readonly id?: string;
  public readonly resource?: string;
  public readonly granteeUserId?: string;
  public readonly parentId?: string;
  public readonly note?: string;

  public constructor(permission: Permission) {
    this.id = permission.id?.value;
    this.resource = JSON.stringify(permission.resource.toJSON());
    this.granteeUserId = permission.granteeUserId.value;
    this.parentId = permission.parentPermissions?.length ? permission.parentPermissions[0].id?.value : undefined; // TODO: Is this correct?
    this.note = permission.note;
  }
}
